<template>
  <div class="sheet-controls">
    <v-expansion-panel nomargin>
      <v-expansion-panel-content>
        <v-subheader slot="header" nopadding>Sheet Controls</v-subheader>
        <v-layout row wrap pa-3>
          <v-flex xs6 pb-2 class="pr-2">
            <v-select
              :value="sheet.paperSize" @input="fn_set('paperSize', $event)"
              :items="Object.keys(sheetSizes)" label="Paper"
              dense outlined hide-details
            ></v-select>
          </v-flex>
          <v-flex xs6 pb-2 class="pl-2">
            <v-select
              :value="sheet.orientation" @input="fn_set('orientation', $event)"
              :items="['Portrait','Landscape']" label="Orientation"
              dense outlined hide-details
            ></v-select>
          </v-flex>
          <v-flex xs6 pb-2 class="pr-2">
            <v-text-field
              :value="sheet.marginTopMm" @input="fn_setNum('marginTopMm', $event)"
              label="Margin Y (mm)" type="number" min="0"
              dense outlined hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs6 pb-2 class="pl-2">
            <v-text-field
              :value="sheet.marginLeftMm" @input="fn_setNum('marginLeftMm', $event)"
              label="Margin X (mm)" type="number" min="0"
              dense outlined hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs6 pb-2 class="pr-2">
            <v-text-field
              :value="sheet.gapXMm" @input="fn_setNum('gapXMm', $event)"
              label="Gap X (mm)" type="number" min="0"
              dense outlined hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs6 pb-2 class="pl-2">
            <v-text-field
              :value="sheet.gapYMm" @input="fn_setNum('gapYMm', $event)"
              label="Gap Y (mm)" type="number" min="0"
              dense outlined hide-details
            ></v-text-field>
          </v-flex>
          <!-- Preview label count — designer only (the generator's count is
               driven by the item list). -->
          <v-flex xs12 pb-2 v-if="showQty">
            <v-text-field
              :value="sheetLabelQty"
              @input="$emit('update:sheetLabelQty', $event === '' ? null : Number($event))"
              label="Labels" type="number" min="1" :placeholder="String(labelsPerPage)"
              dense outlined hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
// Sheet-layout controls, shared by the designer (saves the config with the
// template) and the generator (loads it as defaults, per-run overridable).
// Edits the passed `sheet` object in place — a reactive object owned by the
// parent, so changes flow straight into its grid computeds.
export default {
  props: {
    sheet: { type: Object, required: true },
    sheetSizes: { type: Object, required: true },
    showQty: { type: Boolean, default: false },
    sheetLabelQty: { default: null },
    labelsPerPage: { type: Number, default: 0 }
  },
  methods: {
    fn_set(key, val) { this.$set(this.sheet, key, val); },
    fn_setNum(key, val) { this.$set(this.sheet, key, val === '' ? 0 : Number(val)); }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/barcode/components/sheet_controls.vue